import { PreviewTitle } from './PreviewTitle';

export const ApiPreview = ({ index }: { index: number }) => {
  return <PreviewTitle index={index} />;
};
